// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


/* start of hariharan color code */
:root {
  --h_light_blue: #cde2e7;
  --h_themeBlue: #2d699b;
  --h_white: #fff;
  --h_black: #000;


  --h_lightGray: rgb(245, 245, 245);
  --h_lightGray2: #ebebeb;

  --h_darkGray: #474D57;  
}

/* end of hariharan color code */
.rdt_TableHeadRow .rdt_TableCol{
  font-weight: 600 !important;
}
.rdt_TableHeadRow {
  border: 1px solid transparent !important;
  border-bottom-color: rgba(0, 0, 0, .12) !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;;;EAGf,iCAAiC;EACjC,uBAAuB;;EAEvB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC,kDAAkD;AACpD","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n/* start of hariharan color code */\n:root {\n  --h_light_blue: #cde2e7;\n  --h_themeBlue: #2d699b;\n  --h_white: #fff;\n  --h_black: #000;\n\n\n  --h_lightGray: rgb(245, 245, 245);\n  --h_lightGray2: #ebebeb;\n\n  --h_darkGray: #474D57;  \n}\n\n/* end of hariharan color code */\n.rdt_TableHeadRow .rdt_TableCol{\n  font-weight: 600 !important;\n}\n.rdt_TableHeadRow {\n  border: 1px solid transparent !important;\n  border-bottom-color: rgba(0, 0, 0, .12) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
